import User, { UserId } from '@/shared/models/User';

class AuditAccessFilters {
  constructor(
    readonly users: Array<User>,
    readonly activeUserId: UserId | null,
  ) {
  }
}

export default AuditAccessFilters;